/**
 * FNV-1a 32-bit hash of a string, returned as a fixed-length 8-char hex
 * string. Deterministic, fast and dependency-free. NOT cryptographic — use
 * it for dedup slots, cache keys and shape digests, never for security.
 *
 * Hashes UTF-16 code units (`charCodeAt`), which is stable for any JS
 * string; for the ASCII inputs used here (UUIDs, `path:code` pairs) it
 * matches the canonical byte-wise FNV-1a test vectors.
 */
export function fnv1a(input: string): string {
  // 0x811c9dc5 = FNV-1a 32-bit offset basis; 0x01000193 = FNV prime.
  let hash = 0x811c9dc5;

  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }

  // >>> 0 coerces the signed 32-bit result to unsigned before hex format.
  return (hash >>> 0).toString(16).padStart(8, '0');
}
